import apiClient from './client';
import type { RecipeMedia } from '@/types';

export const mediaApi = {
  /** List all confirmed media for a recipe (returns presigned URLs). */
  list: async (recipeId: string): Promise<RecipeMedia[]> => {
    const res = await apiClient.get<{ data: RecipeMedia[] }>(
      `/recipes/${recipeId}/media`,
    );
    return res.data.data;
  },

  /** Request a presigned S3 PUT URL for a direct browser-to-Wasabi upload. */
  presign: async (
    recipeId: string,
    payload: { filename: string; contentType: string; sizeBytes: number },
  ): Promise<{ mediaId: string; uploadUrl: string }> => {
    const res = await apiClient.post<{ mediaId: string; uploadUrl: string }>(
      `/recipes/${recipeId}/media/presign`,
      payload,
    );
    return res.data;
  },

  /** Confirm that the XHR upload finished. Triggers thumbnail generation server-side. */
  confirm: async (recipeId: string, mediaId: string): Promise<RecipeMedia> => {
    const res = await apiClient.post<{ data: RecipeMedia }>(
      `/recipes/${recipeId}/media/${mediaId}/confirm`,
    );
    return res.data.data;
  },

  /** Delete a media item from storage and DB. Admin-only. */
  delete: async (recipeId: string, mediaId: string): Promise<void> => {
    await apiClient.delete(`/recipes/${recipeId}/media/${mediaId}`);
  },
};
